import intl from 'react-intl-universal';
import store from "@/store";

export function networkErrorMessaging(key: string) {
    const message = intl.formatMessage({ id: key });
    store.appStore.setGlobalMessage({ type: 'error', content: message });
}

export function getTeamsAppDomain() {
    const currentDomain = window.location.host;
    let teamsAppDomain = `https://${currentDomain}/msteams`
    const pdfOnlineTeamsAppDomain = 'https://pdfonline.foxit.com/msteams'
    const azk8sTeamsAppDomain = 'https://online-azk8s.foxitcloud.com/msteams'
    const stgTeamsAppDomain = 'https://pdfonline-stgus.connectedpdf.com/msteams'

    // dev环境
    if (process.env.NODE_ENV === 'development') {
        return azk8sTeamsAppDomain
    }

    // azk8s日本区
    if (currentDomain === 'pdfonline-jpazk8s.connectedpdf.com') {
        return azk8sTeamsAppDomain
    }

    // stg日本区
    if (currentDomain === 'pdfonline-stgjp.connectedpdf.com') {
        return stgTeamsAppDomain
    }

    // 生产环境日本区
    if (currentDomain === 'pdfonline.foxit.co.jp') {
        return pdfOnlineTeamsAppDomain
    }

    return teamsAppDomain
}